import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import { Fancybox } from "@fancyapps/ui";

Swiper.use([Navigation, Pagination]);

/* -------------------------------------------------------------------------- */
/*                              Global functions                              */
/*                                                                            */
/*                     get left/top position of a element                     */
/* -------------------------------------------------------------------------- */
const offset = (el) => {
	const rect = el.getBoundingClientRect();
	return {
		left: rect.left + window.scrollX,
		top: rect.top + window.scrollY,
	};
};

let oldValue = 0;
let newValue = 0;

window.addEventListener('resize', (event) => {
	preventMobileBtn();
});



document.addEventListener("DOMContentLoaded", () => {
	preventMobileBtn();

	/* -------------------------------------------------------------------------- */
	/*                        Sticky Banner Contact Single                        */
	/* -------------------------------------------------------------------------- */
	let scrollPosition = window.scrollY;
	let banContact = document.querySelector(".property-contact");

	if (banContact) {
		window.addEventListener("scroll", (e) => {
			newValue = window.pageYOffset;
			scrollPosition = window.scrollY;

			if (oldValue < newValue && scrollPosition >= 100) {
				banContact.classList.add("is-visible");
			} else if (oldValue > newValue) {
				banContact.classList.remove("is-visible");
			}
			oldValue = newValue;
		});
	}

	/* -------------------------------------------------------------------------- */
	/*                       Filters Mobile Buttons Archive                       */
	/* -------------------------------------------------------------------------- */
	let btnShowFilters = $(".js-show-filter");
	let ctnFilters = document.querySelector(".archive-filter");

	if (!!btnShowFilters) {
		btnShowFilters.on("click", (e) => {
			e.preventDefault();

			ctnMap.classList.remove("is-visible");
			ctnFilters.classList.toggle("is-visible");

			showFiltersAndMap();

			if(btnShowFilters.hasClass('is-active')) $('.js-show-filter div').html('Résultats');
			else $('.js-show-filter div').html('Filter');
		});
	}

	/* -------------------------------------------------------------------------- */
	/*                               Show map mobile                              */
	/* -------------------------------------------------------------------------- */
	let btnShowMap = document.querySelector(".js-show-map");
	let ctnMap = document.querySelector(".archive-results__map");
	let currentUrl = document.location;

	if (btnShowMap) {
		btnShowMap.addEventListener("click", (e) => {
			e.preventDefault();

			ctnMap.classList.toggle("is-visible");
			ctnFilters.classList.remove("is-visible");

			showFiltersAndMap();

			if($(btnShowMap).hasClass('is-active')){
				$('.js-show-map div').html('Liste');
				$(btnShowMap).find('svg use').attr('xlink:href',currentUrl.origin+'/wp-content/themes/maillard-immo/assets/dist/icons/sprite.svg#list');
			} 
			else {
				$('.js-show-map div').html('Carte');
				$(btnShowMap).find('svg use').attr('xlink:href',currentUrl.origin+'/wp-content/themes/maillard-immo/assets/dist/icons/sprite.svg#pin');
			}
		});
	}

	/* -------------------------------------------------------------------------- */
	/*                                 Extend map                                 */
	/* -------------------------------------------------------------------------- */
	let btnExtendMap = document.querySelector(".js-extend-map");
	let ctnExtendMap = document.querySelector(".archive-results");

	if (btnExtendMap) {
		btnExtendMap.addEventListener("click", (e) => {
			ctnExtendMap.classList.toggle("is-extended");
		});
	}

	/* -------------------------------------------------------------------------- */
	/*                             Readmore / Readless                            */
	/* -------------------------------------------------------------------------- */
	$(".readMore").click(function () {
		show_full_excerpt();
	});

	$(".readLess").click(function () {
		hide_full_excerpt();
	});


	/* -------------------------------------------------------------------------- */
	/*                          Lightbox property gallery                         */
	/* -------------------------------------------------------------------------- */
	Fancybox.bind("[data-fancybox]", {
		
	});

	/* -------------------------------------------------------------------------- */
	/*                             Contact form modal                             */
	/* -------------------------------------------------------------------------- */
	let formModal = $(".modal--form");
	let triggerFormModal = $(".js-open-form");

	if (triggerFormModal) {
		let userAgentName = getBrowser();
		//safari => change legend tag to label in order to display asterisk before label 
		$('legend.gfield_label').each(function(){
			var newLabel = document.createElement('label');
			var classes = $(this).attr('class');
			classes = classes.split(/\s+/);
			$(newLabel).addClass(classes);
			$(newLabel).append($(this).html());
			$(this).after(newLabel);
			$(this).remove();
		});

		/* -------------------------------------------------------------------------- */
		/*                               Open the modal                               */
		/* -------------------------------------------------------------------------- */

		function closeModal() {
			formModal.removeClass("is-open");
		}

		triggerFormModal.on("click", e => {
			e.preventDefault();
			$($(e.currentTarget).data('target')).addClass("is-open");
		});

		formModal.on("click", function (event) {
			const isOutside = !event.target.closest(".modal__inner");
			const isCloseButton = event.target.closest('.js-close-modal');
			
			if (isCloseButton || isOutside) {
				closeModal();
			}
		});

		window.addEventListener("keydown", (event) => {
			if (event.key === "Escape") {
				closeModal();
			}
		});
	}
});

function showFiltersAndMap() {
	if ($('.archive-filter').hasClass('is-visible') || $('.archive-results__map').hasClass('is-visible')) {
		if ($('.archive-filter').hasClass('is-visible')) {
			$('.js-show-map').removeClass('is-active');
			$('.js-show-filter').addClass('is-active');
		} else {
			$('.js-show-map').addClass('is-active');
			$('.js-show-filter').removeClass('is-active');
		}
		$('body').addClass('overflow-hidden');
	} else {
		$('.js-show-map').removeClass('is-active');
		$('.js-show-filter').removeClass('is-active');
		$('body').removeClass('overflow-hidden');
	}

	// if the map and filter buttons arre not on the bottom of the page then go up
	if ($('.sm-filters-btn').offset().top + $('.sm-filters-btn').outerHeight() !== $(window).scrollTop() + $(window).outerHeight()) {
		procab_smooth_anchor('.sm-filters-btn', {position: -$(window).outerHeight(), speed: 0});
	}
}

function preventMobileBtn(){
	if (window.matchMedia('(min-width: 1200px)').matches) {
		$(".js-show-filter").each(function(){
			$(this).prop('disabled', true);
		})
	} else {
		$(".js-show-filter").each(function(){
			$(this).prop('disabled', false);
		})
	}
}

function show_full_excerpt() {
	$("a.readMore").hide();
	$("a.readLess").show();
	$("#excerpt-to-cut").addClass("show");
	return false;
}

function hide_full_excerpt() {
	$("a.readMore").show();
	$("a.readLess").hide();
	$("#excerpt-to-cut").removeClass("show");
	return false;
}